export default {
  baseURL: {
    prod: "https://www.awesomewarehouse.com.au/",
    dev: "http://192.168.31.104:18080/",
    test: "http://ip1:port1"
    // prod: 'http://ip2:port2'
  }
};



// WEBPACK FOOTER //
// ./src/config/index.js